import { useState } from "react";
import { Monitor, Smartphone, FileText } from "lucide-react";

/** Renders email HTML in a sandboxed iframe at desktop (600px) or mobile (375px) width, or shows the plain-text twin. */
export const EmailPreviewFrame = ({ html, text, defaultMode = "desktop", height = 560, testid = "email-preview" }) => {
  const [mode, setMode] = useState(defaultMode);
  const width = mode === "mobile" ? 375 : 640;
  const Btn = ({ m, Icon, label }) => (
    <button type="button" onClick={() => setMode(m)} data-testid={`${testid}-${m}`}
      className={`inline-flex items-center gap-1 px-2.5 py-1 text-[11px] rounded border transition-colors ${mode === m ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>
      <Icon className="h-3.5 w-3.5" />{label}
    </button>
  );
  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-1.5 mb-2">
        <Btn m="desktop" Icon={Monitor} label="Desktop" />
        <Btn m="mobile" Icon={Smartphone} label="Mobile" />
        {text != null && <Btn m="text" Icon={FileText} label="Plain text" />}
        <span className="ml-auto text-[10px] text-slate-400">Preview frame only — not a Gmail/Outlook rendering test</span>
      </div>
      <div className="bg-slate-100 rounded-md p-3 flex justify-center overflow-auto" style={{ maxHeight: height + 24 }}>
        {mode === "text" ? (
          <pre className="text-[12px] text-slate-700 whitespace-pre-wrap bg-white border border-slate-200 rounded p-4 w-full max-w-[640px]" data-testid={`${testid}-text`}>{text}</pre>
        ) : (
          <iframe title="Email preview" sandbox="" srcDoc={html} style={{ width, height, border: "1px solid #e2e8f0", background: "#fff", borderRadius: 6 }} data-testid={`${testid}-frame`} />
        )}
      </div>
    </div>
  );
};
